import { useContext } from "react";
import { ensure } from "sprint-common-web";

import { DeliveryEndpointsDataContext } from "../../../../common/data/lookup-data-providers/DeliveryEndpointsDataProvider";
import { DeliveryEndpoint } from "../../../../common/types/DeliveryEndpoint";

export const useDeliveryEndpointsData = () => {
    const { deliveryEndpoints } = useContext(DeliveryEndpointsDataContext);

    const getDeliveryEndpoint = (deliveryEndpointId: string) =>
        getDeliveryEndpointOrDefault(deliveryEndpoints, deliveryEndpointId);

    return { getDeliveryEndpoint };
};

const getDeliveryEndpointOrDefault = (
    deliveryEndpoints: DeliveryEndpoint[],
    deliveryEndpointId: string | undefined
): DeliveryEndpoint | undefined => {
    if (!deliveryEndpointId) {
        return undefined;
    }

    const deliveryEndpoint = deliveryEndpoints.find((item) => item.id === deliveryEndpointId);

    ensure(deliveryEndpoint);

    return deliveryEndpoint;
};
